import { render } from "./BackToTopButton.vue?vue&type=template&id=a7213bbe&scoped=true"
import script from "./BackToTopButton.vue?vue&type=script&lang=js"
export * from "./BackToTopButton.vue?vue&type=script&lang=js"

import "./BackToTopButton.vue?vue&type=style&index=0&id=a7213bbe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7213bbe"]])

export default __exports__